export const SET_UNSAVED_FLAG = "SET_UNSAVED_FLAG"
export const SET_APP_STATE_INITIAL = "SET_APP_STATE_INITIAL"
export const SET_COMPANY_DATA = "SET_COMPANY_DATA"
export const SET_PROJECT_DETAIL = "SET_PROJECT_DETAIL"
export const SET_APP_IS_LOADING = "SET_APP_IS_LOADING"
export const SET_APP_ERROR = "SET_APP_ERROR"
export const SET_DATA_SETTINGS = "SET_DATA_SETTINGS"
export const SET_VIEW_ALL_SECTIONS_ENABLED = "SET_VIEW_ALL_SECTIONS_ENABLED"
export const SET_COMPANY_DATA_VALID = "SET_COMPANY_DATA_VALID"
export const SET_REPORT_IS_LOADING = "SET_REPORT_IS_LOADING"